import { ISettings } from '@fluentui/react';
import { TeamsButtonStyles } from './TeamsButton.styles';
import { TeamsDefaultButtonStyles } from './TeamsDefaultButton.styles';
import { TeamsDetailPanelV2Styles } from './TeamsDetailPanelV2.styles';

export const M365TeamsStyles: { [key: string]: ISettings } = {
  DetailPanelV2: { styles: TeamsDetailPanelV2Styles },
  Button: { styles: TeamsButtonStyles },
  DefaultButton: { styles: TeamsDefaultButtonStyles },
};
